import type { IconName } from '@travelata-libs/ui-kit';

/** Насколько вероятно и быстро туроператор подтвердит продукт. */
export enum ConfirmationType {
  Quick = 'quick',
  Long = 'long',
  Cancel = 'cancel',
}

/** Пункт шторки: поясняющая строка со своей иконкой. */
export interface ConfirmationDetail {
  icon: `${IconName}`;
  text: string;
}
